import React from 'react';
import buttonImage from '../buttonimage.webp';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import { supabase } from '../supabaseClient';
import mirrorimage from '../mirrorimage.webp';

function Acceptance({ goBack, goHome, handleSaveProgress }) {
    console.log('Debug: Acceptance component rendered'); // Debug log

    const cardStyle = {
        width: '100%',
        maxWidth: '600px',
        border: '2px solid black',
        borderRadius: '10px',
        backgroundImage: `url(${cardBackgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        marginBottom: '20px',
        padding: '20px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    };

    const textStyle = {
        fontFamily: 'Times New Roman, Times, serif',
        fontSize: '16px',
        fontWeight: 'normal',
        color: 'black',
        textAlign: 'center',
        lineHeight: '1.5',
        marginBottom: '16px',
    };

    const handleSaveProgressInternal = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                alert('User not logged in!');
                return;
            }
            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'acceptance',
                    animated_helper: 'no', // always set to 'no'
                    timestamp: new Date().toISOString(),
                });
            if (progressError) {
                alert('Failed to save progress: ' + progressError.message);
                return;
            }
            alert('Session progress has been saved successfully!');
        } catch (err) {
            alert('An unexpected error occurred while saving progress.');
        }
    };

    return (
        <div
            style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '16px',
            }}
        >
            <style>{`
                @media (max-width: 600px) {
                    .acceptance-btn-row {
                        flex-direction: row !important;
                        gap: 6px !important;
                        width: 100% !important;
                        justify-content: space-between !important;
                        margin: 0 !important;
                        padding: 0 2vw 0 2vw !important;
                    }
                    .acceptance-btn-row button {
                        width: 32vw !important;
                        min-width: 0 !important;
                        max-width: 110px !important;
                        font-size: 15px !important;
                        padding: 10px 0 !important;
                        margin: 0 !important;
                    }
                }
            `}</style>
            <h2
                style={{
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '36px',
                    fontWeight: 'bold',
                    color: '#4B5563',
                    textAlign: 'center',
                    marginTop: '16px',
                }}
            >
                Acceptance
            </h2>
            {/* Top Card with Image, Title, and Subtitle */}
            <div
                style={{
                    width: '100%',
                    maxWidth: '600px',
                    borderRadius: '10px',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    border: '2px solid black',
                    marginBottom: '24px',
                    overflow: 'hidden',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    textAlign: 'center',
                }}
            >
                <img
                    src={mirrorimage}
                    alt="Mirror"
                    style={{
                        width: '100%',
                        borderRadius: '10px 10px 0 0',
                        objectFit: 'cover',
                        maxHeight: '220px',
                    }}
                />
                <div
                    style={{
                        padding: '24px',
                        background: 'rgba(255,255,255,0.85)',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                    }}
                >
                    <h2
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '28px',
                            fontWeight: 'bold',
                            color: '#4B5563',
                            margin: '0 0 16px 0',
                        }}
                    >
                        Acceptance
                    </h2>
                    <p
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: '#4B5563',
                            margin: 0,
                        }}
                    >
                        Accepting what is, as it is, is the first step to peace.
                    </p>
                </div>
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                    marginBottom: '16px',
                }}
            >
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        • Acceptance of what is allows our central channel to open for energy movement.<br />
                        • Acceptance releases resistance.<br />
                        • Acceptance does not mean you agree with something or want more of it.<br />
                        • If we cannot accept what is we will be stuck with it.<br />
                        • Deciding to accept what is can offer immediate relief from the discomfort of resistance.<br />
                        • Acceptance can be a powerful move on its own even without the whole formula.
                    </div>
                </div>
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        1. Are you willing to accept what is happening or what has happened?<br />
                        2. Have you experienced difficulty with accepting the reality of something?<br />
                        3. Is it easier to deny something than to accept it as the reality you are experiencing?<br />
                        4. Do you see the difference between acceptance and agreement?<br />
                        5. Have you had good results when you try to push something away to get rid of it when it already exists in your reality?<br />
                        6. Are you willing to stop and accept the reality you are currently in?
                    </div>
                </div>
            </div>
            <div style={cardStyle}>
                <p style={textStyle}>
                    Acceptance is a powerful tool for personal growth. It allows us to release resistance and embrace the reality of what is, without judgment or denial.
                </p>
                <p style={textStyle}>
                    By accepting our circumstances, emotions, and experiences, we create space for transformation and inner peace. Acceptance does not mean agreeing with or liking everything; it simply means acknowledging reality as it is.
                </p>
            </div>
            <div style={cardStyle}>
                <p style={textStyle}>
                    Reflect on something in your life that you have struggled to accept. Consider how embracing acceptance might bring you relief and clarity.
                </p>
            </div>
            <div
                className="acceptance-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px',
                    marginBottom: '16px',
                    width: '100%',
                }}
            >
                <button
                    className="acceptance-btn"
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        color: 'white',
                    }}
                    onClick={goBack}
                >
                    Back
                </button>
                <button
                    className="acceptance-btn"
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        color: 'white',
                    }}
                    onClick={goHome}
                >
                    Home
                </button>
                <button
                    className="acceptance-btn"
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        color: 'white',
                    }}
                    onClick={handleSaveProgressInternal}
                >
                    Save
                </button>
            </div>
        </div>
    );
}

export default Acceptance;